import clsx from 'clsx';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './elements.module.css';

const setIconStyle = (activeView, value) => {
  return activeView === value ? colors.brand.blue : colors.neutral.gray;
};

interface Props {
  value: string;
  icon: any;
  activeView: string;
  setActiveView: (string) => any;
}

const ElementNavigationIcon = ({
  value,
  icon,
  activeView,
  setActiveView,
}: Props) => {
  const iconColor = setIconStyle(activeView, value);

  return (
    <div
      onClick={() => setActiveView(value)}
      className={clsx(
        classes.iconContainer,
        activeView === value && classes.active,
      )}
    >
      <IconButton>
        <Icon color={iconColor}>{icon}</Icon>
      </IconButton>
    </div>
  );
};

export default ElementNavigationIcon;
